import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { UnifiedEvent } from '@/hooks/useUnifiedCalendar';

interface Props {
  event: UnifiedEvent;
  nameById: Map<string, string>;
  children: React.ReactNode;
}

export function CalendarEventTooltip({ event, nameById, children }: Props) {
  const mentors = event.mentorIds.map((id) => nameById.get(id)).filter(Boolean) as string[];
  const expert = event.expertId ? nameById.get(event.expertId) : undefined;

  return (
    <Tooltip delayDuration={200}>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent side="top" className="max-w-xs space-y-1 text-left">
        <p className="font-medium leading-tight">{event.title}</p>
        <p className="text-xs text-muted-foreground">{event.contextLabel}</p>
        {(mentors.length > 0 || expert) && (
          <p className="text-xs text-muted-foreground">
            {mentors.length > 0 && <>Mentor: {mentors.join(', ')}</>}
            {mentors.length > 0 && expert && ' · '}
            {expert && <>Experto: {expert}</>}
          </p>
        )}
        <p className="text-xs text-muted-foreground">
          {event.startTime
            ? `${event.startTime}${event.endTime ? ` – ${event.endTime}` : ''}`
            : 'Todo el día'}
        </p>
      </TooltipContent>
    </Tooltip>
  );
}
